export enum HierarchyDefaults {
  StaleTime = 60 * 10000,
}
